import { useTranslation } from 'next-i18next';
import { Tag, Link } from '@/components';
import { useState } from 'react';
import dayjs from 'dayjs';

export default function ListLayout({ posts, title }) {
	const [searchValue, setSearchValue] = useState('');
	const filteredBlogPosts = posts.filter((frontMatter) => {
		const searchContent =
			frontMatter.title + frontMatter.body + frontMatter.keywords.map(({ name }) => name).join(' ');
		return searchContent.toLowerCase().includes(searchValue.toLowerCase());
	});
	const { t } = useTranslation('common');
	// console.log(posts);

	return (
		<>
			<div className='divide-y'>
				<div className='pt-6 pb-8 space-y-2 md:space-y-5'>
					<h1 className='text-3xl font-extrabold leading-9 tracking-tight text-gray-900 dark:text-gray-100 sm:text-4xl sm:leading-10 md:text-6xl md:leading-14'>
						{t('all-posts')}
					</h1>
					<div className='relative max-w-lg'>
						<input
							aria-label='Search articles'
							type='text'
							onChange={(e) => setSearchValue(e.target.value)}
							placeholder={t('search-articles')}
							className='block w-full px-4 py-2 text-gray-900 bg-white border border-gray-300 rounded-md dark:border-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-800 dark:text-gray-100'
						/>
						<svg
							className='absolute w-5 h-5 text-gray-400 right-3 top-3 dark:text-gray-300'
							xmlns='http://www.w3.org/2000/svg'
							fill='none'
							viewBox='0 0 24 24'
							stroke='currentColor'
						>
							<path
								strokeLinecap='round'
								strokeLinejoin='round'
								strokeWidth={2}
								d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
							/>
						</svg>
					</div>
				</div>
				<ul>
					{!filteredBlogPosts.length && 'No posts found.'}
					{filteredBlogPosts.map((frontMatter) => {
						const { slug, publishedAt, title, shortBody, categories: keywords } = frontMatter;
						return (
							<li key={slug} className='py-4'>
								<article className='space-y-2 xl:grid xl:grid-cols-4 xl:space-y-0 xl:items-baseline'>
									<dl>
										<dt className='sr-only'>Published on</dt>
										<dd className='text-base font-medium leading-6 text-gray-500 dark:text-gray-400'>
											<time dateTime={publishedAt}>
												{dayjs.unix(+publishedAt / 1000).format('DD/MM/YYYY')}
											</time>
										</dd>
									</dl>
									<div className='space-y-3 xl:col-span-3'>
										<div>
											<h3 className='text-2xl font-bold leading-8 tracking-tight'>
												<Link href={`/post/${slug}`} className='text-gray-900 dark:text-gray-100'>
													{title}
												</Link>
											</h3>
											<div className='flex flex-wrap'>
												{/* <pre>{frontMatter.keywords}</pre> */}
												{keywords.map((key) => (
													<Tag key={key.name} text={key.name} />
												))}
											</div>
										</div>
										<div className='prose text-gray-500 max-w-none dark:text-gray-400'>
											{shortBody}
										</div>
									</div>
								</article>
							</li>
						);
					})}
				</ul>
			</div>
		</>
	);
}
